import { useState, type ReactElement } from 'react';
import type { EntityTypeDto } from '@gr/core/content/entities/dto';
import type { FieldDefinition } from '@gr/core/content/entities/fields';
import { useT } from '../../../../app/di';
import { Alert } from '../../../../ui-kit/Alert/Alert';
import { Button } from '../../../../ui-kit/Button/Button';
import { FormAlert, useServerForm } from '../../../../ui-kit/form/form';
import type { ServerOutcome } from '../../../../ui-kit/form/server-errors';
import { FieldsEditor } from '../FieldsEditor/FieldsEditor';
import { fromRows, postFieldsFormValues, type FieldsFormValues } from '../model/fields-form';

export interface PostFieldsFormProps {
  fields: readonly FieldDefinition[];
  entityTypes: readonly EntityTypeDto[];
  onSubmit(fields: FieldDefinition[]): Promise<ServerOutcome>;
}

/** ENT-UC-4: пользовательские поля постов блога. */
export function PostFieldsForm({ fields, entityTypes, onSubmit }: PostFieldsFormProps): ReactElement {
  const { t } = useT();
  const [saved, setSaved] = useState(false);
  const initial = postFieldsFormValues(fields);
  const { form, submit } = useServerForm<FieldsFormValues>({
    defaultValues: initial,
    values: initial,
    fields: ['fields'],
    onSubmit: async (values) => {
      setSaved(false);
      const outcome = await onSubmit(fromRows(values.fields));
      setSaved(outcome.success);
      return outcome;
    },
  });
  return (
    <form className="u-stack" onSubmit={submit} noValidate>
      {saved ? <Alert tone="success">{t('common.saved')}</Alert> : null}
      <FormAlert form={form} />
      <FieldsEditor form={form} entityTypes={entityTypes} affectedCount={1} tracksTitle={false} />
      <div>
        <Button type="submit" variant="primary" loading={form.formState.isSubmitting}>
          {t('common.save')}
        </Button>
      </div>
    </form>
  );
}
